/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.confirmbox[_ngcontent-%COMP%]{top:25%;position:fixed}.headerIcon[_ngcontent-%COMP%]{width:100%;background-color:#1ebebc;text-align:center;padding:5px}.modal-title[_ngcontent-%COMP%]{font-size:45px}.modal-body[_ngcontent-%COMP%]{background-color:#f5f5f5;text-align:center;color:#000}.btn-popout[_ngcontent-%COMP%]{color:#1ebebc;background-color:#fff;border:2px solid #1ebebc;margin-bottom:10px;width:9em;margin-right:5px}.btn[_ngcontent-%COMP%]:hover{background-color:#1ebebc;color:#fff}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvbWVzc2FnZS9jb25maXJtLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvc2hhaXphci9Qcm9qZWN0cy9NQU1QVS9NeUdvdi9wb3J0YWwtZmUvc3JjL2FwcC9tZXNzYWdlL2NvbmZpcm0uY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/message/confirm.component.css.shim.ngstyle.ts